import { Fragment } from "react";
import LoadingSpinner from "../../ui/spinner/LoadingSpinner";
import styles from "../../styles/components/leads/LeadStatusProgress.module.css";

export default function LeadStatusProgress({
  statuses = [],
  currentStatusOrder = null,
  onStatusSelect = null,
  pendingStatusId = null,
}) {
  return (
    <div className={styles.progress}>
      {statuses.map((status, index) => {
        const value = typeof status === "object" ? status.order : status;
        const keyVal = typeof status === "object" ? status.id : `order-${value}`;
        const isReached = currentStatusOrder !== null && value <= currentStatusOrder;
        const isLast = index === statuses.length - 1;

        const nextStatus = !isLast ? statuses[index + 1] : null;
        const nextValue = nextStatus
          ? typeof nextStatus === "object"
            ? nextStatus.order
            : nextStatus
          : null;
        const isLineActive =
          nextValue !== null &&
          currentStatusOrder !== null &&
          nextValue <= currentStatusOrder;

        const stepClassName = `${styles.step} ${isReached ? styles.stepReached : ""}`;
        const stepContent = (
          <span className={`${styles.stepText} ${isReached ? styles.stepTextReached : ""}`}>
            {value}%
          </span>
        );
        const isSelectable = typeof onStatusSelect === "function" && typeof status === "object";
        const isPending = isSelectable && pendingStatusId !== null && status.id === pendingStatusId;

        return (
          <Fragment key={keyVal}>
            {isSelectable ? (
              <button
                type="button"
                className={`${stepClassName} ${styles.stepButton}`}
                title={status.name}
                aria-label={status.name ? `Mover a ${status.name} (${value}%)` : `Mover a ${value}%`}
                aria-busy={isPending}
                onClick={() => onStatusSelect(status)}
              >
                {stepContent}
                {isPending && (
                  <span className={styles.stepSpinner} data-testid="lead-status-spinner">
                    <LoadingSpinner size={40} thickness={2} color="var(--surface-accent)" />
                  </span>
                )}
              </button>
            ) : (
              <div className={stepClassName}>{stepContent}</div>
            )}
            {!isLast && (
              isLineActive
                ? <div className={styles.line} />
                : <div className={styles.gap} />
            )}
          </Fragment>
        );
      })}
    </div>
  );
}
